import { _ } from "../../../core/polyglot/polyglot.js";
import abstractKeyFigureDocument from "../shared/abstractKeyFigureDocument.js";
import session from "../../../core/session.js";
import singleKeyFigureReportWidget from "./singleKeyFigureReportWidget.js";

/**
 * `keyFigureReportDocument` displays multiple key-figures with the abilities
 * to choose from existing presets or by browsing through the KeyFigures groups
 * and individually select the key-figures.
 *
 * @param {object} spec - Parameter object
 * @param {object} my - protected fields holder
 * @return {*}
 */

/**
 * Todo: Add JSDoc comment
 */
function keyFigureReportDocument(spec, my) {
	spec ||= {};
	my ||= {};

	const that = abstractKeyFigureDocument(spec, my);
	my.location = "kpi-reports";

	let reportsCache = {};

	that.title = _("KPI report");
	that.subtitle = _("Your numbers to follow");

	that.help = {
		summary: _(
			"This feature gives you a report setup of the KPIs of your choice.",
		),
		sections: [
			{
				title: _("A single KPI"),
				content: _(
					"Each KPI is shown by its current value in reference to minimum, maximum and average. If a goal value is set for the KPI that is also shown.",
				),
			},
		],
	};

	that.showKeyFigures = function (query) {
		my.previousPeriodPicker.setSelected(
			parseInt(query.numberOfPreviousPeriods, 10),
		);

		my.showKeyFigures(query.preset);
	};

	my.renderContentOn = function (html) {
		html.render(
			my.section({
				content: my
					.getVisibleKeyFigures()
					.map((keyFigure) => reportsCache[keyFigure.getId()]),
			}),
		);
	};

	my.presetChanged = function () {
		buildReports();
		setValuesForReports();
	};

	my.show = function () {
		buildReports();
		setValuesForReports();
		that.update();
	};

	my.setValueFor = async function (singleReport) {
		const company = session.getCompany();
		const period = session.getPeriod();

		const numPeriods = my.previousPeriodPicker.getSelected();
		const lastPeriods = company.getLatestPeriods(numPeriods, period);

		const result = await my.keyFigureResultService.getValuesForPeriods({
			keyFigures: [singleReport.getKeyFigure()],
			periods: lastPeriods,
		});

		singleReport.showEntries(result);
	};

	my.keyFigureChanged = function (keyFigures) {
		keyFigures.forEach((keyFigure) => {
			if (reportsCache[keyFigure.getId()]) {
				return;
			}

			reportsCache[keyFigure.getId()] = singleKeyFigureReportWidget({
				numPeriods: my.previousPeriodPicker.getSelected(),
				keyFigure,
			});

			my.setValueFor(reportsCache[keyFigure.getId()]);
		});

		my.switchToCustomPreset(keyFigures);
	};

	my.setNumberOfPeriods = function () {
		forEachReportType((key) => {
			const singleReport = reportsCache[key];
			my.setValueFor(singleReport);
		});
	};

	function buildReports() {
		const keyFigures = my.getVisibleKeyFigures();
		reportsCache = {};

		keyFigures.forEach((keyFigure) => {
			reportsCache[keyFigure.getId()] = singleKeyFigureReportWidget({
				keyFigure,
			});
		});
	}

	function forEachReportType(fn) {
		Object.keys(reportsCache).forEach((key) => {
			const value = reportsCache[key];
			fn(key, value);
		});
	}

	function setValuesForReports() {
		forEachReportType((key, singleReport) => {
			my.setValueFor(singleReport);
		});
	}

	return that;
}

export default keyFigureReportDocument;
